import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiConfiguration } from '../api-configuration';
import { JobOfferPostulantResponse } from 'src/app/shared/model/job-offer-postulant';
import { JobOfferPostulant } from 'src/app/shared/model/job-postulant-list';
import { StatusProcess } from 'src/app/core/enum/status-process';

@Injectable({
  providedIn: 'root',
})
export class JobOfferPostulantService {
  private endpoint = '/oferta-empleo-postulante';

  constructor(private http: HttpClient, private config: ApiConfiguration) {}

  postulate(idJobOffer: string): Observable<{
    type: string;
    dto: any[];
    listMessage: string[];
  }> {
    const body = { idJobOffer };
    const url = `${this.config.rootUrl}${this.endpoint}`;

    return this.http.post<{ type: string; dto: any[]; listMessage: string[] }>(
      url,
      body
    );
  }

  checkIfPostulantExists(idJobOffer: string): Observable<{
    type: string;
    dto: { exists: boolean };
    listMessage: string[];
  }> {
    const url = `${this.config.rootUrl}${this.endpoint}/existe/${idJobOffer}`;
    return this.http.get<{
      type: string;
      dto: { exists: boolean };
      listMessage: string[];
    }>(url);
  }

  updateRevisedByIdJobOfferPostulant(
    idJobOfferPostulant: string
  ): Observable<{ type: string; dto: any; listMessage: string[] }> {
    const url = `${this.config.rootUrl}${this.endpoint}/revisado/${idJobOfferPostulant}`;
    const body = { revised: 1 };
    return this.http.patch<{ type: string; dto: any; listMessage: string[] }>(
      url,
      body
    );
  }

  updateSelectedByIdJobOfferPostulant(
    idJobOfferPostulant: string,
    selected: number = 1
  ): Observable<{ type: string; dto: any; listMessage: string[] }> {
    const url = `${this.config.rootUrl}${this.endpoint}/seleccionado/${idJobOfferPostulant}`;
    const body = { selected };
    return this.http.patch<{ type: string; dto: any; listMessage: string[] }>(
      url,
      body
    );
  }

  getPostulantsByIdJobOffer(idJobOffer: string): Observable<any> {
    const url = `${this.config.rootUrl}${this.endpoint}/obtener-por-oferta-empleo/${idJobOffer}`;
    return this.http.get<any>(url);
  }

  getPostulantById(
    idJobOfferPostulant: string
  ): Observable<JobOfferPostulantResponse> {
    const url = `${this.config.rootUrl}${this.endpoint}/${idJobOfferPostulant}`;
    return this.http.get<JobOfferPostulantResponse>(url);
  }

  getJobOffersByUserId(): Observable<{
    type: string;
    dto: { jobOfferPostulants: JobOfferPostulant[] };
    listMessage: string[];
  }> {
    const url = `${this.config.rootUrl}${this.endpoint}/usuario`;
    return this.http.get<{
      type: string;
      dto: { jobOfferPostulants: JobOfferPostulant[] };
      listMessage: string[];
    }>(url);
  }

  getPostulantDetailById(
    idJobOfferPostulant: string
  ): Observable<JobOfferPostulantResponse> {
    const url = `${this.config.rootUrl}${this.endpoint}/${idJobOfferPostulant}`;
    return this.http.get<JobOfferPostulantResponse>(url);
  }

  updateStatusProcessByIdJobOfferPostulant(
    idJobOfferPostulant: string,
    status: StatusProcess
  ): Observable<{ type: string; dto: any; listMessage: string[] }> {
    const url = `${this.config.rootUrl}${this.endpoint}/estado-postulacion/${idJobOfferPostulant}`;
    const body = { statusProcess: status };
    return this.http.patch<{ type: string; dto: any; listMessage: string[] }>(
      url,
      body
    );
  }
}
